import React, { FunctionComponent, lazy, Suspense } from 'react'

import { Theme, useTheme } from '../Theme'
import styles from './style.module.scss'

interface Props {
  size?: string
}

// Cash and Pegasus/Kelpie spinners ship as separate async chunks. Most users
// only ever see one theme, so eagerly bundling both forces an inline base64
// PNG (Cash, ~5 KB) and ~45 KB of inline animated SVG keyframes (Pegasus)
// into every initial bundle. We keep the wrapping `<div data-testid=
// 'loading-icon-svg'>` in the lazy chunks so existing testid lookups still
// resolve once the chunk loads.
const CashSpinner = lazy(async () => import('./CashSpinner'))
const PegasusSpinner = lazy(async () => import('./PegasusSpinner'))

export const Spinner: FunctionComponent<Props> = ({ size = '56' }) => {
  const {
    theme: { selected },
  } = useTheme()

  // Plain CSS spinner — also serves as the Suspense fallback while the
  // theme-specific chunk loads. The shared testid keeps synchronous lookups
  // like `getByTestId('loading-icon-svg')` working before lazy resolution.
  const fallback = <div data-testid='loading-icon-svg' className={styles.spinner}></div>

  if (selected === Theme.Cash) {
    return (
      <Suspense fallback={fallback}>
        <CashSpinner size={size} />
      </Suspense>
    )
  }

  if (selected === Theme.Pegasus || selected === Theme.Kelpie || selected === Theme.KelpieMint) {
    return (
      <Suspense fallback={fallback}>
        <PegasusSpinner size={size} />
      </Suspense>
    )
  }

  return fallback
}
